import { Button, IconName } from '@optimus-web/core';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { EmailValidationProvider } from '@mews-commander/form';
import { NewPlatformProfileDialog } from './NewPlatformProfileDialog';

export const NewPlatformProfileButton = () => {
    const [{ active, onClose }, openDialog] = useDialog();
    return (
        <EmailValidationProvider>
            <Button icon={IconName.AddCustomer} onClick={openDialog} variant="tertiary" type="submit">
                <LocalizedText textKey={TextKey.InviteUsers} />
            </Button>
            {active && <NewPlatformProfileDialog closeDialog={onClose} />}
        </EmailValidationProvider>
    );
};
